import withTranslate from "@pathwright/ui/src/components/lng/withTranslate"
import LazyQuillEditor from "@pathwright/ui/src/components/quill/LazyQuillEditor"
// import { getCustomColors } from "../editor/BlockStyles/utils"
import { templateVariablesMap } from "@pathwright/blocks-engine"

// TEMP FIX: importing getCustomColors results in circulum import error.
const lsKey = "customBlocksColors"
const getCustomColors = () => JSON.parse(window.localStorage.getItem(lsKey))

const getBlocksColorsForQuill = () => {
  const { color: customColor, backgroundColor: customBackgroundColor } = {
    ...(getCustomColors() || {})
  }

  const customColors = []

  if (customColor) customColors.push(customColor)
  if (customBackgroundColor) customColors.push(customBackgroundColor)

  return [{ color: customColors }, { background: customColors }]
}

const BlocksQuillEditor = withTranslate(
  ({ LoadingComponent, placeholder, t, createCustomToolbar, ...rest }) => {
    return (
      <LazyQuillEditor
        placeholder={placeholder || t("blocks.text_editor.placeholder")}
        variables={templateVariablesMap}
        contentType="text"
        createCustomToolbar={
          createCustomToolbar
            ? createCustomToolbar
            : ({ getMergedToolbarConfig }) =>
                getMergedToolbarConfig({
                  config: getBlocksColorsForQuill()
                })
        }
        useAdvancedColorPicker
        LoadingComponent={() =>
          LoadingComponent ? (
            <LoadingComponent />
          ) : (
            // more seemless loading experience
            <></>
          )
        }
        {...rest}
      />
    )
  }
)

BlocksQuillEditor.displayName = "BlocksQuillEditor"

export default BlocksQuillEditor
